module.exports = __webpack_public_path__ + "static/media/the-house-by-the-cemetery.a2c3cdb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backdrops/the-house-by-the-cemetery.jpg
// module id = 294
// module chunks = 0